import { Mail, Phone, Facebook, Instagram, MapPin } from "lucide-react";
import { CONTACT, waLink, WHATSAPP_DISPLAY } from "@/lib/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-navy text-white pt-16 pb-8" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 border-b border-white/10 pb-12">
          <div>
            <p className="font-display font-bold text-2xl tracking-tight">
              KING <span className="text-brand-red">OF</span> SOURCING
            </p>
            <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
              Entreprise basée en Italie (Europe), King of Sourcing connecte n'importe quel pays aux fournisseurs chinois et coréens : sourcing, achat et livraison partout dans le monde.
            </p>
            <div className="mt-6 flex gap-3">
              <a href={CONTACT.socials.facebook} target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="flex h-10 w-10 items-center justify-center rounded-md border border-white/15 hover:bg-brand-red hover:border-brand-red transition-colors duration-300">
                <Facebook size={18} />
              </a>
              <a href={CONTACT.socials.instagram} target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="flex h-10 w-10 items-center justify-center rounded-md border border-white/15 hover:bg-brand-red hover:border-brand-red transition-colors duration-300">
                <Instagram size={18} />
              </a>
              <a href={CONTACT.socials.tiktok} target="_blank" rel="noopener noreferrer" data-testid="social-tiktok" aria-label="TikTok" className="flex h-10 w-10 items-center justify-center rounded-md border border-white/15 hover:bg-brand-red hover:border-brand-red transition-colors duration-300">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
                  <path d="M16.5 3c.36 2.02 1.5 3.62 3.5 3.98v2.83c-1.2.11-2.35-.14-3.5-.75v6.02c0 3.9-3.16 6.32-6.5 5.55-2.9-.66-4.66-3.7-3.8-6.62.6-2.06 2.36-3.5 4.5-3.7.4-.04.8-.02 1.3.02v2.95c-.4-.13-.78-.2-1.17-.15-1.1.15-1.9 1.02-1.9 2.1 0 1.24 1.02 2.16 2.28 2.03 1.14-.12 1.99-1.12 1.99-2.34V3h2.5z" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-5">Services</p>
            <ul className="space-y-3 text-sm">
              {["Sourcing Gros", "Sourcing Détail", "Vérification Fournisseurs", "Logistique & Livraison"].map((s) => (
                <li key={s}>
                  <a href="#services" className="text-white/80 hover:text-brand-red transition-colors duration-300">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-5">Entreprise</p>
            <ul className="space-y-3 text-sm">
              <li><a href="#apropos" className="text-white/80 hover:text-brand-red transition-colors duration-300">À propos</a></li>
              <li><a href="#process" className="text-white/80 hover:text-brand-red transition-colors duration-300">Comment ça marche</a></li>
              <li><a href="#avis" className="text-white/80 hover:text-brand-red transition-colors duration-300">Avis clients</a></li>
              <li><a href="#devis" className="text-white/80 hover:text-brand-red transition-colors duration-300">Demander un devis</a></li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-5">Contact</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-phone" className="flex items-center gap-3 text-white/80 hover:text-brand-red transition-colors duration-300">
                  <Phone size={16} /> {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 text-white/80 hover:text-brand-red transition-colors duration-300">
                  <Mail size={16} /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/80" data-testid="footer-location">
                <MapPin size={16} /> {CONTACT.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col gap-3 text-xs text-white/40">
          <p data-testid="footer-legal" className="text-center sm:text-left">
            {CONTACT.legalName}
            {CONTACT.registeredAddress ? ` · Siège social : ${CONTACT.registeredAddress}` : ""}
            {` · Tél : ${CONTACT.landline}`}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p>© {new Date().getFullYear()} King of Sourcing — {CONTACT.legalName}. Tous droits réservés.</p>
            <p>Chine · Corée · Livraison dans le monde entier 🌍</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
